export const VALID_SERVICE_AREA_ZIPS: ReadonlySet<string> = new Set([
  "20601","20602","20603","20604","20606","20607","20608","20609","20610","20611",
  "20612","20613","20615","20616","20617","20618","20619","20620","20621","20622",
  "20623","20624","20625","20626","20627","20628","20629","20630","20632","20634",
  "20635","20636","20637","20639","20640","20643","20645","20646","20650","20653",
  "20656","20657","20658","20659","20660","20661","20662","20664","20667","20670",
  "20674","20675","20676","20677","20678","20680","20682","20684","20685","20686",
  "20687","20688","20689","20690","20692","20693","20695","20703","20704","20705",
  "20706","20707","20708","20709","20710","20712","20714","20715","20716","20717",
  "20718","20719","20720","20721","20722","20725","20726","20731","20732","20735",
  "20736","20737","20738","20740","20741","20743","20744","20745","20746","20747",
  "20748","20749","20750","20752","20753","20754","20757","20758","20762","20768",
  "20769","20770","20772","20773","20774","20775","20781","20782","20783","20784",
  "20785","20787","20788","20791","20792",
]);

export const normalizeZip = (raw: unknown): string | null => {
  if (typeof raw !== "string") return null;
  const trimmed = raw.trim();
  const m = trimmed.match(/^(\d{5})(?:-?\d{4})?$/);
  return m ? m[1] : null;
};

export const isServiceAreaZip = (raw: unknown): boolean => {
  const z = normalizeZip(raw);
  return !!z && VALID_SERVICE_AREA_ZIPS.has(z);
};

export const OUT_OF_AREA_MESSAGE =
  "Thanks for reaching out. It looks like your project may be outside our regular service area. If you believe this is an error or your project is nearby, please call us directly.";